import { render, staticRenderFns } from "./ThumbnailMainAction.vue?vue&type=template&id=dc5ffd5c"
import script from "./ThumbnailMainAction.vue?vue&type=script&lang=js"
export * from "./ThumbnailMainAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports